import FileDownload from 'js-file-download';
import swal from 'sweetalert2';

export default {
    methods: {
        decodeBase64(base64File) {
            let signature;

            try {
                signature = atob(base64File.replace(/\s/g, ''));
            } catch (e) {
                if (e.code !== 5) {
                    throw e;
                }
            }

            return signature;
        },
        getFileIcon(type) {
            let icon;

            switch (type) {
            case 'application/pdf':
                icon = 'fa-file-pdf';
                break;
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
                icon = 'fa-file-image';
                break;
            default:
                icon = 'fa-file';
                break;
            }

            return `far ${icon}`;
        },
        formatBytes(bytes, decimals) {
            if (bytes == 0) return '0 Bytes';
            const k = 1000;
            const dm = decimals + 1 || 1;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
        },
        showFile(base64File, title, type, download = false, showPrintDialog = false) {
            // decode base64 string, remove space for IE compatibility
            if (base64File === null) {
                swal.fire({ icon: 'error', title: 'File cannot be found' });
                throw new Error('Cannot find file');
            }

            const binary = atob(base64File.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i += 1) {
                view[i] = binary.charCodeAt(i);
            }

            const newBlob = new Blob([view], { type });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            if (download || (type !== 'application/pdf' && type !== 'text/html' && type !== 'image/jpeg')) {
                FileDownload(newBlob, title, type);
            } else {
                const blobUrl = URL.createObjectURL(newBlob);
                const newWindow = window.open(blobUrl, '_blank');

                if (!newWindow) {
                    swal.fire({ icon: 'error', text: 'Popup blocker detected, please allow pops ups for this site' });
                } else {
                    newWindow.focus();

                    if (showPrintDialog) {
                        newWindow.addEventListener('DOMContentLoaded', () => {
                            newWindow.print();

                            newWindow.onafterprint = () => {
                                newWindow.close();
                            };
                        });
                    }
                }

                URL.revokeObjectURL('');
            }
        },
    },
};
